



















import {onMounted, ref} from "@vue/composition-api"
import axios, {AxiosError} from "axios"
import {env} from "@/environment"
import router from "@/router"

export default {
  name: 'RoomsList',
  setup() {
    const rooms = ref([])
    const isError = ref(false)

    onMounted(() => {
      axios.get(`${env.backendUrl}/rooms`)
        .then(response => {
          rooms.value = response.data
        })
        .catch((error: AxiosError) => {
          isError.value = error.isAxiosError
          throw error
        })
    })

    return {
      rooms,
      isError,
      enterRoom: (roomId: string) => {
        const roomUrl = router.resolve(`/rooms/${roomId}`).href
        window.open(roomUrl, '_blank')
      }
    }
  }
}
